import { render, staticRenderFns } from "./SubDepartmentList.vue?vue&type=template&id=6c4d1492&"
import script from "./SubDepartmentList.vue?vue&type=script&lang=js&"
export * from "./SubDepartmentList.vue?vue&type=script&lang=js&"
import style0 from "./SubDepartmentList.vue?vue&type=style&index=0&id=6c4d1492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports